export const InstallationGuide: React.FC = () => {
  return (
    <div>
      <h1>Install this thing</h1>
      <p>installation guide</p>
    </div>
  );
};
